import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "icn-file-thumbnail",
  templateUrl: "thumbnail.component.html",
  styleUrls: ["thumbnail.component.scss"],
})
export class FileThumbnailComponent {
  @Input() thumbnailUrl = "";
  @Input() canRemove = true;
  @Output() remove = new EventEmitter();

  onRemove() {
    this.remove.emit(this);
  }
}
